import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound, LogOut } from "lucide-react";
import { api, tokens, errMsg } from "../lib/api";
import { Section } from "./Common";
import PanelSettings from "./PanelSettings";
import PanelJobs from "./PanelJobs";
import PanelExport from "./PanelExport";
import PanelLeaves from "./PanelLeaves";
import PanelMembers from "./PanelMembers";
import PanelImport from "./PanelImport";
import PanelAudit from "./PanelAudit";
import PanelReset from "./PanelReset";

function PanelPin({ reload }) {
  const [pin, setPin] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post("/auth/panel-login", { pin });
      tokens.setPanel(r.data.panelToken);
      toast.success("Panel terbuka");
      reload();
    } catch (ex) {
      toast.error(errMsg(ex));
    }
  };
  return (
    <form onSubmit={submit} data-testid="panel-pin-form" className="card flex max-w-md flex-col gap-3 p-5">
      <p className="text-sm text-[#7a6667]">Panel otomatis terbuka untuk Leader & Manager. Lainnya masukkan PIN panel.</p>
      <input data-testid="panel-pin-input" className="field tracking-[0.4em]" type="password" inputMode="numeric" maxLength={6}
        value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} placeholder="PIN panel" />
      <button data-testid="panel-pin-submit" className="btn-primary"><KeyRound size={16} /> Buka panel</button>
    </form>
  );
}

export default function Panel({ data, reload }) {
  const [members, setMembers] = useState([]);
  const loadMembers = useCallback(async () => {
    try {
      const r = await api.get("/members");
      setMembers(r.data);
    } catch (e) { /* not privileged */ }
  }, []);
  useEffect(() => { if (data.privileged) loadMembers(); }, [data.privileged, loadMembers]);
  const [auditVersion, setAuditVersion] = useState(0);
  const refreshAll = () => { loadMembers(); reload(); setAuditVersion((v) => v + 1); };
  const closePanel = () => { localStorage.removeItem("crk_panel"); reload(); };
  return (
    <Section id="panel" eyebrow="Panel Leader & Manager" title="Pengaturan & pengelolaan"
      right={data.panel && !data.me?.privileged ? <button data-testid="panel-close" onClick={closePanel} className="btn-ghost"><LogOut size={15} /> Tutup panel</button> : null}>
      {!data.privileged ? <PanelPin reload={reload} /> : (
        <div className="grid gap-4 lg:grid-cols-2" data-testid="panel-content">
          {data.settings?.panelPinWeak && (
            <div data-testid="panel-pin-weak-warning" className="rounded-xl border border-brand bg-brand-soft p-3 text-sm font-semibold text-brand-deep lg:col-span-2">
              PIN panel masih bawaan (1234) atau terlalu mudah. Selama belum diganti, PIN panel tidak bisa dipakai untuk membuka panel. Ganti di bagian Pengaturan → "PIN panel baru".
            </div>
          )}
          <PanelSettings />
          <PanelJobs onRestored={refreshAll} />
          <PanelExport members={members} today={data.today} />
          <PanelLeaves members={members} leaveTypes={data.leaveTypes} today={data.today} onChanged={reload} version={data.leaves.map((l) => l.id).join(",")} />
          <PanelImport onDone={refreshAll} />
          <div className="lg:col-span-2"><PanelMembers members={members} jobFunctions={data.jobFunctions} onChanged={refreshAll} /></div>
          <div className="lg:col-span-2"><PanelAudit version={`${auditVersion}-${data.leaves.length}`} /></div>
          {data.me?.isManager && <div className="lg:col-span-2"><PanelReset meName={data.me.name} onDone={refreshAll} /></div>}
        </div>
      )}
    </Section>
  );
}
